module.exports = __webpack_public_path__ + "static/img/item-l_j_cherry.da023a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item-l_j_cherry.png
// module id = 0PeX
// module chunks = 1